import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact';
import { defaultConfig } from '../../config';

const parseInteger = (value) =>
  value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0;

export default () => {
  const { query, response } = useAppState();
  const { updateSearch } = useActions();

  const from = parseInteger(query.products?.from);
  const size = parseInteger(response.products.size);
  const total = parseInteger(response.products.total);
  const to = from + size;

  const loadMore = () => {
    // change defaultConfig.serpSize to how many products to load on each click
    updateSearch({
      products: {
        size:
          parseInteger(query.products.size) +
          parseInteger(defaultConfig.serpSize),
      },
    });
  };

  return (
    <div class="gc_load_button ns-d-flex ns-justify-content-center">
      {to < total && (
        <button
          id="acs_paging_btn"
          class="load_more_btn btn rich-btn btn--secondary"
          onClick={loadMore}
        >
          Load More
        </button>
      )}
    </div>
  );
};
